import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static targets = ['sortableItem', 'sortableList', 'orderInput', 'template'];

  static values = {
    minItemsSize: Number,
    reorderPath: String,
  };

  static classes = ['ghost'];

  connect() {
    this.initializeSortable();
    this.currentIndex = this.sortableItemTargets.length;
  }

  initializeSortable() {
    this.sortable = new Sortable(this.sortableListTarget, {
      animation: 150,
      ghostClass: this.ghostClass,
      onEnd: () => {
        this.dispatch('dragEnd', { prefix: false });
      },
    });
  }

  addItem(event) {
    event.preventDefault();

    let newItem = document.importNode(this.templateTarget.content, true);

    this.currentIndex += 1;
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(newItem);
    tempDiv.innerHTML = tempDiv.innerHTML.replace(
      /__INDEX__/g,
      this.currentIndex,
    );

    [newItem] = tempDiv.children;

    this.sortableListTarget.appendChild(newItem);

    this.dispatch('itemAdded', {
      detail: { itemCount: this.sortableItemTargets.length },
      prefix: false,
    });
  }

  deleteItem(event) {
    event.preventDefault();

    if (this.minItemsSizeValue && this.minItemsSizeValue > 0) {
      const remainingItems = this.sortableListTarget.children.length;
      if (remainingItems === 1) {
        return;
      }
    }

    const item = event.target.closest('li');
    if (item) {
      item.remove();
      this.dispatch('itemRemoved', {
        detail: { itemCount: this.sortableItemTargets.length },
        prefix: false,
      });
    }
  }
}
